import { gql } from '../../../../../hooks'

export const DELETE_IMAGES = gql`
  mutation AdministrationDeleteReportImages($id: ID!) {
    aDelete(path: "other/images", id: $id) {
    }
  }
`

export const LIST_IMAGES = gql`
  query AdministrationListReportImages(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(path: "other/images", filter: $filter, page: $page, limit: $limit) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
